import { Link } from 'react-router-dom';
import { useGetOrganizationsQuery } from '../app/api';
import { AdminScreen, ListCount, card, primaryButtonStyle } from '../features/admin/adminUi';
import { formatAreaKmSq } from '../features/admin/formUi';

export default function Organizations() {
  const { data } = useGetOrganizationsQuery();

  return (
    <AdminScreen title="ORGANIZATIONS" subtitle="Tenants — each owns its own users, projects and coverage boundary">
      <div className="scrl" style={{ overflowY: 'auto', padding: 24, minHeight: 0 }}>
        <div style={{ maxWidth: 760, margin: '0 auto' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
            <ListCount n={data?.total ?? 0} noun="organization" />
            <Link to="/organizations/new" style={{ ...primaryButtonStyle(true), textDecoration: 'none' }}>
              + New organization
            </Link>
          </div>
          {data?.items.map((o) => (
            <Link
              key={o.id}
              to={`/organizations/${o.id}/edit`}
              style={{ ...card, display: 'block', marginBottom: 8, textDecoration: 'none', color: 'inherit' }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: 14, fontWeight: 600 }}>{o.name}</span>
                <span className="mono" style={{ fontSize: 11, color: 'var(--text-dim)' }}>
                  {new Date(o.createdAt).toISOString().slice(0, 10)}
                </span>
              </div>
              <div style={{ display: 'flex', gap: 14, marginTop: 6, fontSize: 11.5, color: 'var(--text-faint)' }}>
                <span>{o.polygon ? 'Boundary set' : 'No boundary'}</span>
                <span className="mono">max {o.maxAreaKmSq != null ? formatAreaKmSq(o.maxAreaKmSq) : '—'}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </AdminScreen>
  );
}
